import React from 'react';
import { ChevronRight, AlertCircle, Clock, AlertTriangle } from 'lucide-react';

const typeConfig = {
  overdue_payments: {
    Icon: AlertCircle,
    stripe: 'bg-red-500',
    bg: 'bg-red-50 hover:bg-red-100/60',
    border: 'border-red-200',
    text: 'text-red-800',
    sub: 'text-red-500',
    badge: 'bg-red-100 text-red-700',
    badgeLabel: 'Urgent',
  },
  member_behind: {
    Icon: AlertTriangle,
    stripe: 'bg-amber-500',
    bg: 'bg-amber-50 hover:bg-amber-100/60',
    border: 'border-amber-200',
    text: 'text-amber-800',
    sub: 'text-amber-500',
    badge: 'bg-amber-100 text-amber-700',
    badgeLabel: 'Review',
  },
  pending_application: {
    Icon: Clock,
    stripe: 'bg-blue-500',
    bg: 'bg-blue-50 hover:bg-blue-100/60',
    border: 'border-blue-200',
    text: 'text-blue-800',
    sub: 'text-blue-500',
    badge: 'bg-blue-100 text-blue-700',
    badgeLabel: 'Pending',
  },
};

const ActionItem = ({ item, onClick }) => {
  const cfg = typeConfig[item.type] || typeConfig.pending_application;
  const { Icon } = cfg;

  return (
    <button
      onClick={() => onClick(item)}
      className={`w-full flex items-center gap-3 p-4 rounded-xl ${cfg.bg} border ${cfg.border} transition-all duration-200 text-left group`}
    >
      <div className={`w-[3px] self-stretch rounded-full ${cfg.stripe} flex-shrink-0`} />
      <Icon className={`w-4 h-4 ${cfg.text} opacity-70 flex-shrink-0`} />
      <div className="flex-1 min-w-0">
        <p className={`${cfg.text} text-sm font-semibold truncate`}>{item.title}</p>
        <p className={`${cfg.sub} text-xs mt-0.5`}>{item.description}</p>
      </div>
      <span className={`px-2 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wide flex-shrink-0 ${cfg.badge}`}>
        {cfg.badgeLabel}
      </span>
      <ChevronRight className="w-4 h-4 text-slate-400 group-hover:translate-x-0.5 transition-transform flex-shrink-0" />
    </button>
  );
};

export default ActionItem;
